const transfers = {
  transfer: "Perdavimas", // translated 
  transfers: "Pervedimai", // translated 
  dateAndTime: "Data ir laikas", // translated 
  transferFrom: "Pervežimas iš", // translated 
  duration: "Trukmė", // translated 
  numOfPersons: "Asmenų skaičius", // translated 
  baggageAllowance: "Bagažo pašalpa", // translated 
  small: "Mažas", // translated 
  big: "Didelis", // translated 
  provider: "Teikėjas", // translated 
  vehicle: "Transporto priemonė", // translated 
  distance: "Atstumas", // translated 
  price: "Kaina", // translated 
  inboundJourney: "Kelionė į šalį", // translated 
  outboundJourney: "Išvykstamoji kelionė", // translated 
  arrivalTime: "Atvykimo laikas", // translated 
  flightDetails: "Skrydžio detalės", // translated 
  inboundPickupDate: "Atvykimo paėmimo data", // translated 
  outboundPickupDate: "Išvykimo paėmimo data", // translated 
  travelInfo: "Informacija apie keliones", // translated 
  flightsInfo: "Informacija apie skrydžius", // translated 
  airportYouAreFlyingFrom: "Oro uostas, iš kurio skrendate", // translated 
  airportYouAreFlyingTo: "Oro uostas, į kurį skrendate", // translated 
  inboundFlightNumber: "Atvykstamojo skrydžio numeris", // translated 
  outboundFlightNumber: "Išvykstančio skrydžio numeris", // translated 
  inboundAirlineName: "Atvykstančios oro linijos pavadinimas", // translated 
  outboundAirlineName: "Išvykimo oro linijos pavadinimas", // translated 
  tripMode: "Kelionės režimas", // translated 
  airportToPoint: "Oro uostas į tašką", // translated 
  pointToAirport: "Point To Airport", // translated 
  roundTrip: "Kelionė pirmyn ir atgal", // translated 
  destinationPoint: "Paskirties taškas", // translated 
  originPoint: "Kilmės taškas", // translated 
  transferType: "Perdavimo tipas", // translated 
  min: "Min", // translated 
  max: "Maks", // translated 
  pieces: "Gabalai", // translated 
  cancelationIs: "atšaukimas yra", // translated 
};


export default transfers;
